<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">

    <br><br>
    <fg-input type="text"
              label="Name"
              placeholder="Name"
              v-model="affiliateCompany.profile.companyName"
              :disabled="affiliateCompany.archived"
              @keyup.enter="saveAffiliateCompany()"
              ref="tofocus"/>

    <div class="row">
      <fg-input class="col-6"
                type="text"
                label="Contact Name"
                placeholder="Contact Name"
                v-model="affiliateCompany.profile.contactName"
                :disabled="affiliateCompany.archived"
                @keyup.enter="saveAffiliateCompany()"/>

      <!-- <fg-input class="col-6"
                type="text"
                label="Contact Position"
                placeholder="Contact Position"
                v-model="affiliateCompany.profile.contact.position"
                :disabled="affiliateCompany.archived"
                @keyup.enter="saveAffiliateCompany()"/> -->
    </div>

    <div class="row">
      <fg-input class="col-7"
                type="text"
                label="Contact Email"
                placeholder="Contact Email"
                v-model="affiliateCompany.profile.email"
                :disabled="affiliateCompany.archived"
                @keyup.enter="saveAffiliateCompany()"/>

      <fg-input class="col-5"
                type="text"
                label="Contact Phone"
                placeholder="Contact Phone"
                v-model="affiliateCompany.profile.phone"
                :disabled="affiliateCompany.archived"
                @keyup.enter="saveAffiliateCompany()"/>
    </div>
    
    <fg-input label="Notes">
      <el-input type="textarea"
                :autosize="{minRows: 2}"
                placeholder="Notes"
                v-model="affiliateCompany.notes"
                @keyup.enter="saveAffiliateCompany()"/>
    </fg-input>

    <!-- <fg-input label="Company">
      <el-select class="select-transparent removeReadonly" v-model="companyId" :filterable="false">
        <el-option v-for="item in $store.getters.companies"
                    :value="item.id"
                    :label="item.profile.companyName"
                    :key="item.id"/>
      </el-select>
    </fg-input> -->

    <span slot="footer" class="dialog-footer">
      <div class="row">
        <span v-if="modalState.mode != 'Create'" class="col-1">
          <button v-if="deletable" class="btn btn-danger" @click="deleteAffiliate()">Delete</button>
          <button v-else-if="affiliateCompany.archived" class="btn" @click="toggleArchive()">Unarchive</button>
          <button v-else class="btn" @click="toggleArchive()">Archive</button>
          <!-- <button v-else class="btn" @click="test">Archive</button> -->
        </span>

        <span class="ml-auto col-4">
          <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
          <button class="btn btn-success" @click="saveAffiliateCompany()">Save</button>
        </span>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import {Affiliate, AffiliateCompanyProxy, Person} from 'src/classes/datamodel.js'
import { progress } from '../../utils'
export default {
  name: 'Affiliate-Company-Modal',
  computed: {
    modalState () {
      return this.$store.state.modal
    },
    title () {
      return this.modalState.mode + ' Affiliate Company'
    },
    visible () {
      return this.modalState.current == 'Affiliate Company'
    },
    affiliateCompany () {
      return this.visible && this.modalState.object ? this.modalState.object : new AffiliateCompanyProxy({contact: new Person(), profile: {}})
    },
    archived: { get()  { return this.affiliateCompany.archived; },
                set(archived) { this.affiliateCompany.archived = archived }
    },
    deletable: { get() { return this.affiliateCompany.deletable },
                 set(deletable) { this.affiliateCompany.deletable = deletable }
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('closeModal')
    },
    toggleArchive () {
      this.archived = !this.archived
    },
    async saveAffiliateCompany () {
      progress.start()
      progress.set(0.4)
      const action =  this.$store.state.modal.mode == 'Edit' ? 'updateRestObject' : 'createRestObject'
      const res = await this.$store.dispatch(action, new AffiliateCompanyProxy(this.affiliateCompany))
      console.log('saveAffiliateCompany(): res = ', res)
      if (res) {
        if (!res.errors) {
          this.$notify({successMessage: 'Saved!'})
          this.closeModal()
        }
        else {
          //console.log('res.errors = ', res.errors[0].message)
          if (res.status == 401) {
            this.closeModal()
            this.$router.push('/login')
          }
          else {
            // We don't show the session invalid message because the apiService already reroutes to login page
            if (!res.errors[0].toLowerCase().includes('session')) {
              this.$notify({errorMessage: res.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue.message)})
            }
          }
        }
      }
      else {
        console.log('res = ', res)
      }
      progress.done()
    }
  },
  watch: {
    visible: function (elem) {
      if (this.visible) {
        // doesn't work without the timeout..
        setTimeout(() => this.$refs.tofocus.$el.children[1].focus(), 500)
      }
    }
  }
}
</script>

<style>

</style>